import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { Loader2 } from "lucide-react";
import { AuthProvider, useAuth } from "./context/AuthContext";
import AuthPage from "./pages/AuthPage";
import AuthCallback from "./pages/AuthCallback";
import Dashboard from "./pages/Dashboard";
import ChartDetail from "./pages/ChartDetail";
import SynastryPage from "./pages/SynastryPage";
import "./App.css";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading)
    return (
      <div className="min-h-screen cosmic-bg flex items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin" style={{ color: "#D4AF37" }} />
      </div>
    );
  return user ? children : <Navigate to="/auth" replace />;
}

function AuthGate() {
  const { user, loading } = useAuth();
  if (loading) return null;
  return user ? <Navigate to="/" replace /> : <AuthPage />;
}

function AppRouter() {
  const location = useLocation();
  // Process the OAuth callback FIRST, before any protected route runs.
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/auth" element={<AuthGate />} />
      <Route path="/" element={<Protected><Dashboard /></Protected>} />
      <Route path="/chart/:id" element={<Protected><ChartDetail /></Protected>} />
      <Route path="/synastry" element={<Protected><SynastryPage /></Protected>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster theme="dark" position="top-center" richColors />
        <AppRouter />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
